import React, { Fragment, Component } from 'react'
import {Redirect} from 'react-router-dom';
import { Layout, Button, Icon, Divider, Row, Col, Progress, Spin, Form, Card, Tag } from 'antd';
import { Link } from 'react-router-dom';
import { SALES_ROLE } from '../../constants/overview';
const {Content } = Layout;
const FormItem = Form.Item;
class KnowMoreDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      redirect: false,
      data: [], 
      isLoading:true,
    }
  }
  componentWillMount () {
    this.getKnowMoreData()
  }
  getKnowMoreData() {
    let that = this
    let id = this.props.eventId
    window.axios.get(window.API_URL + 'corporate/events/'+id)
    .then(function (response) {
      that.setState({data: response.data, isLoading: false})
    })
    .catch(function (error) {
      console.log(error);
    })
  }
  goBack() {
    this.setState({redirect: true})
  }
  deactivateEvent() {
    let that = this
    let id = this.props.eventId
    window.axios.put(window.API_URL + 'corporate/events/'+id+'/deactivate')
    .then(function (response) {
      that.setState({redirect: true, isLoading: false})
      that.props.postUpdate()
    })
    .catch(function (error) {
      console.log(error);
    })
  }
  render() {
    const formItemLayout = null;
    if(this.state.isLoading) {
      return (
        <div className="spiner">
          <Spin size="large"/>
        </div>
      )
    }
    let data = this.state.data
    let going = data.employees.going ? data.employees.going : 0
    let not_going = data.employees.not_going ? data.employees.not_going : 0
    let not_sure = data.employees.not_sure ? data.employees.not_sure : 0
    // let sum = going + not_going + not_sure
    let event_options = data.event_options ? data.event_options : []
    let event_contacts = data.event_contacts ? data.event_contacts : []
    let event_status = data.event_status === "active" ? true : false
    let show_footer = (data.event_type === "default_events" || data.sponsor === null) ? false : data.completed_or_not
    let event_description = data.description
    return (
      <div>
        <h2  style={{marginBottom: 24}} className="event-pre-header"> Event Preview </h2>
        <form>
          <Card
          cover={<img alt="event" src={data.image_url}/>}
          className="card-know-more">
          <h4 className="drawer-label-color"><b> Event Title </b></h4>
          <Row gutter={24} style={{marginTop: '-20',marginBottom: 5}}>
            <Col className="gutter-row" span={24} style={{marginBottom: '-12'}}>
              <FormItem {...formItemLayout} style={{marginBottom: 0}}>
                <p style={{color: '#4d6189'}}>{data.name}</p>
              </FormItem>
            </Col>
          </Row>
          <h4 className="drawer-label-color"><b> Date and Time </b></h4>
          <Row gutter={24} style={{marginTop: '-20',marginBottom: 5}}>
            <Col className="gutter-row" span={12} style={{marginBottom: '-15'}}>
            <FormItem {...formItemLayout} style={{marginBottom: 0}}>
              <label style={{marginTop: 20,color: '#A2A2A2'}}>Starts from </label>
                <h4 style={{marginTop: '-20'}}>{data.start_time}</h4>
            </FormItem>    
            </Col>
            <Col className="gutter-row" span={12} style={{marginTop: '0'}} justify="end">
            <FormItem {...formItemLayout} style={{marginBottom: 0}}>
              <label style={{marginTop: 20,color: '#A2A2A2'}}>Ends on </label>
                <h4 style={{marginTop: '-20'}}>{data.end_time}</h4> 
            </FormItem>    
            </Col> 
          </Row>
          <h4 className="drawer-label-color"><b> Entry Fee </b></h4>
          <Row gutter={24} style={{marginTop: '-20',marginBottom: 5}}>
            <Col className="gutter-row" span={24} style={{marginBottom: '-12'}}>
              <FormItem {...formItemLayout} style={{marginBottom: 0}}>
                { data.price > "0" ?
                <p style={{color: '#4d6189'}}>{data.price}</p>
                :  
                <p style={{color: '#4d6189'}}>Free Entry</p>
                }
              </FormItem>
            </Col>
          </Row>
          { data.description === null ? null : 
          <div>
          <h4 className="drawer-label-color" style={{marginTop: '-6'}}><b> Event Description </b></h4> 
          <Row gutter={24} style={{marginTop: '-8',marginBottom: 8}}>
            <Col className="gutter-row" span={24} style={{marginBottom: '-12'}}>
              <FormItem {...formItemLayout} style={{marginBottom: 10}}>
                
                  <p style={{lineHeight: '1.5',color: '#4d6189',marginBottom: 10}} dangerouslySetInnerHTML={{__html: event_description}} />
                  
              </FormItem>    
            </Col>
          </Row>
          </div>
          }
          {data.event_address === null ? null : <h4 className="drawer-label-color"><b> Event Address </b></h4> }
          <Row gutter={24} style={{marginTop: '-8',marginBottom: 8}}>
            <Col className="gutter-row" span={24} style={{marginBottom: '-15'}}>
              <FormItem {...formItemLayout} style={{marginBottom: 10}}>
                  <p style={{lineHeight: '1.5',color: '#4d6189'}}>{data.event_address}</p>
              </FormItem>    
            </Col>
          </Row>
          {data.event_type === "default_events" ? null : 
          <div style={{marginBottom: 18}}>
          <h4 className="drawer-label-color"><b>Employees RSVP</b></h4>
          
            <Tag style={{marginRight: 10}}>Not Sure - {not_sure}</Tag>
            <Tag color="blue" style={{marginRight: 10}}>Going - {going}</Tag>
            <Tag color="red" style={{marginRight: 10}}>Not Going - {not_going}</Tag>
              
          </div>
          }
          {event_options.length > 0 ? <h4 className="drawer-label-color"><b>Poll Result</b></h4> : null }
          <div style={{marginBottom: 10}}>
            {event_options.map(function(object, i){
              let options = object.options
              let count = i + 1
                return (
                  <div key={i}>
                    
                    <p style={{marginBottom: 8}}><b>{count}. {object.name}</b></p>
                    {options.map(function(obj, j){
                      let padding_left =  j === 0  || (j % 4 == 0)  ? '0' : '12'
                      return (
                            <Tag color="blue" style={{marginBottom: 10,marginRight: 10}}>{obj.name} - {obj.count}</Tag>            
                      )
                    })} 
                    
                  </div> 

                )
              })} 
          </div>
          {event_contacts.length > 0 ? <h4 className="drawer-label-color"><b>Contact Details</b></h4> : <div><br/></div> }
          <Row gutter={24} style={{marginLeft: 0}}>
          {
            event_contacts.map(function(object, i){
              return (
                <FormItem {...formItemLayout} key={i} style={{marginBottom: '-12'}}>
                <Row gutter={24} key={i} style={{marginBottom: '-12',marginTop: '-12'}}>
                    <Col className="gutter-row" span={24}>
                      <p><Icon type="contacts" style={{color: '#2168f3'}}/>  {object.name}</p>
                    </Col>
                    <Col className="gutter-row" span={24} style={{marginTop: '-35'}}>
                      <p><Icon type="phone" style={{transform: 'rotate(100deg)',color: '#2168f3'}} />  {object.mobile}</p>
                    </Col>
                    <Col className="gutter-row" span={24} style={{marginTop: '-35'}}>
                      <p><Icon type="mail" style={{color: '#2168f3'}}/>  {object.email}</p>
                    </Col>
                </Row>
                </FormItem>
              )
            })
          }
          </Row>
          
          </Card>
        </form>
        <div>
        { show_footer ? <Row type='flex' justify='start' className="drawer-footer">
          { event_status ? 
          <Button type="danger" onClick={this.deactivateEvent.bind(this)} disabled={SALES_ROLE === 'sales'} style={{marginLeft: 25,marginTop: 10}}>Unpublish</Button> : <Button onClick={this.deactivateEvent.bind(this)} style={{marginLeft: 25,marginTop: 10}}>Publish</Button> }
          <Button type="primary" disabled={SALES_ROLE === 'sales'} style={{marginLeft: 25,marginTop: 10}}><a href={"/wellness-calendar/event/" + String(data.id) + "/edit"} >Edit</a></Button>
          
        </Row> : null }
        
        </div> 
      </div>
    );
  }
}

export default KnowMoreDrawer;